import React, { createContext, useContext } from 'react';

const SubmitConfirmationJobIdContext = createContext<string>('');
const SubmitConfirmationJobGlobalIdContext = createContext<string>('');

export const SubmitConfirmationJobIdsProvider: React.FC<{ jobId: string; jobGlobalId: string }> = ({
  children,
  jobId,
  jobGlobalId,
}) => {
  return (
    <SubmitConfirmationJobIdContext.Provider value={jobId}>
      <SubmitConfirmationJobGlobalIdContext.Provider value={jobGlobalId}>
        {children}
      </SubmitConfirmationJobGlobalIdContext.Provider>
    </SubmitConfirmationJobIdContext.Provider>
  );
};

export const useJobIdValue = (): string => {
  return useContext(SubmitConfirmationJobIdContext);
};

export const useJobGlobalIdValue = (): string => {
  return useContext(SubmitConfirmationJobGlobalIdContext);
};
